import SocialLink from "./SocialLink";
import styles from "./PrimarySection.module.css";
import whatsappImg from "../../assets/icons/whatsapp.png";
import facebookImg from "../../assets/icons/facebook.png";
import instagramImg from "../../assets/icons/instagram.png";
import logo from '../../assets/icons/logo.svg'

const PrimarySection = (props) => {
  return (
    <section
      className={`${styles.section} ${props.className}`}
      style={{ backgroundImage: `url(${props.backgroundImage})` }}
    >
      {props.children}
      <div className={styles['logoContainer']}>
        <img className={styles.logo} src={logo} alt='logo' />
      </div>
      <div className={styles.linksContainer}>
        <SocialLink href="#" src={whatsappImg} alt="whatsapp" />
        <SocialLink href="#" src={instagramImg} alt="instagram" />
        <SocialLink
          imgClassName={styles.linkImg}
          href="#"
          src={facebookImg}
          alt="facebook"
        />
      </div>
    </section>
  );
};

export default PrimarySection;
